<template>
	<article class="list-item">
		<div class="field inline row">
			<span class="label centered rigid">
				<slot name="setting-label"></slot>
			</span>
			<span class="row">
				<div class="display-text centered rigid">
					<slot name="setting-value"></slot>
				</div>
			</span>
		</div>

		<span class="gap"></span>
	</article>
</template>

<script>
import Vue from 'vue';
export default {
	name: 'SettingStatic'
};
</script>



// WEBPACK FOOTER //
// ./src/components/SettingStatic.vue